import "styles/common/alignment.less";
import React, { useEffect, useState } from "react";

import { DownOutlined } from "@ant-design/icons";
import { Dropdown, Button, Spin, message } from "antd";
import taxCalendar from "assets/images/new-questionnaire/calendar.svg";
import { useUser } from "hooks/common/useUser";
import { useDispatch } from "react-redux";
import { setCurrentDocumentYear } from "redux/reducers/document";
import { setTaxYears } from "redux/reducers/taxYears";
import { useGetTaxYearsMutation } from "services/tax-years";
import { TaxYear } from "types/taxYear";
import { logError } from "utils/sentry";

interface ApiDropdownProps {
  onSelect: (_value: string) => void;
  value: string | undefined;
  placeholder?: string;
}

const TaxYearSelection: React.FC<ApiDropdownProps> = ({ onSelect, value, placeholder = "Select an option" }) => {
    const [getTaxYears] = useGetTaxYearsMutation();
    const dispatch = useDispatch();
    const { user } = useUser();

    const [options, setOptions] = useState<TaxYear[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [selected, setSelected] = useState<string | undefined>(value || "2024/2025");

    useEffect(() => {
        const fetchTaxYears = async () => {
            try {
                setLoading(true);
                const { data } = await getTaxYears({}).unwrap();
                setOptions(data?.years || []);
                dispatch(setTaxYears(data?.years));
            } catch (error) {
                message.error("Error fetching tax years");
                logError(error, {
                    function: "fetchTaxYears",
                    message: "Error fetching tax years",
                    clientId: user?.id,
                });
            } finally {
                setLoading(false);
            }
        };

        if (user) {
            fetchTaxYears();
        }
        fetchTaxYears();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, getTaxYears, user]);

    const handleMenuClick = (e: any) => {
        setSelected(e.key);
        onSelect(e.key);
        dispatch(setCurrentDocumentYear(e.key));
    };

    const items = options.map(option => ({
        key: option.year,
        label: (
            <span className="mr10">{option.year}</span>
        ),
        disabled: option.year !== "2024/2025",
    }));

    return (
        <Dropdown menu={{ items, onClick: handleMenuClick, selectedKeys: [selected || ""] }} className="w100" disabled={loading}>
            <div className="w100 flex-column">
                <Button className="space-between" size={"large"} icon={<img src={taxCalendar} alt="Tax Calendar" />}>
                    {loading ? <Spin size="small" /> : selected || placeholder} <DownOutlined />
                </Button>
            </div>
        </Dropdown>
    );
};

export default TaxYearSelection;
